import { FC } from 'react'
import { SpaceProps } from 'styled-system'
import { PackageLabel } from '..'
import { HoverWrapper, StyledPackages } from './Packages.style'
import { Hover } from 'yolda-web-ui'
import { useTranslation } from 'react-i18next'

export interface PackagesProps extends SpaceProps {
  data?: {
    height?: number
    length?: number
    number?: number
    text?: string
    type?: string
    weight?: number
    width?: number
  }[]
  fullWidth?: boolean
  variant?: 'default' | 'alternative'
  showFullList?: boolean
}

const Packages: FC<PackagesProps> = ({ data, fullWidth, variant, showFullList = true }) => {
  const { t } = useTranslation()
  const isMixedPackages: boolean = !!(data && data?.length > 2)

  const renderDetailedPackageLabelList = () =>
    data?.map?.((item, index) => (
      <PackageLabel
        height={item?.height}
        key={index}
        length={item?.width}
        number={item.number}
        text={item.text}
        type={item.type || ''}
        variant={variant}
        weight={item?.weight}
        width={item?.length}
      />
    ))

  const MixedPackageLabel = () => {
    return (
      <PackageLabel
        variant={variant}
        text={t('packages.mixedPackageLabel')}
        type={'other'}
        isMixedPackages={isMixedPackages}
      />
    )
  }

  return (
    <StyledPackages fullWidth={fullWidth} variant={variant}>
      {showFullList ? (
        renderDetailedPackageLabelList()
      ) : isMixedPackages ? (
        <HoverWrapper>
          <Hover
            renderComponent={renderDetailedPackageLabelList()}
            containerComponent={<MixedPackageLabel />}
          />
        </HoverWrapper>
      ) : (
        renderDetailedPackageLabelList()
      )}
    </StyledPackages>
  )
}

export default Packages
